import React from 'react';

const ObservationCard = ({ observation }) => {
    return (    
        <tr>
            <td>
                <div className="d-flex px-2 py-1">
                    <div>
                        <img src={"../assets/img/"+observation.icon} className="avatar avatar-sm me-3 border-radius-lg" alt="user1"/>
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">{observation.activityType}</h6>
                        <p className="text-xs text-secondary mb-0">{observation.activityName}</p>
                    </div>
                </div>
            </td>
            <td>
                <p className="text-xs font-weight-bold mb-0">
                {observation.observationDate.split('T')[0].split('-').reverse().join('/')}
                   </p>
                   
                <p className="text-xs text-secondary mb-0">{observation.observationDate.substr(11, 8)}</p>
            </td>
            <td>
                <p className="text-xs font-weight-bold mb-0">
                {observation.activityLastDate.split('T')[0].split('-').reverse().join('/')}
                   </p>
                   
                <p className="text-xs text-secondary mb-0">{observation.activityLastDate.substr(11, 8)}</p>
            </td>
            <td className="align-middle text-center text-sm">
                <span className="badge badge-sm bg-gradient-success">
                {observation.activityFrequency}
                    </span>
            </td>
            <td className="align-middle text-center">
                <span className="text-secondary text-xs font-weight-bold">{observation.id}</span>
            </td>
            <td className="align-middle">
                <a href="#" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                    Edit
                </a>
            </td>
        </tr>
    );
}

export default ObservationCard;